import React, { Fragment, useState } from 'react';
import { Col, Card, CardHeader, CardBody, Collapse } from 'reactstrap';
import { H3, P, Image, Btn } from '../../AbstractElements';
import timeline4 from '../../assets/images/social-app/timeline-4.png';
import { ProfileIntro, SocialNetworks, Dribbble, Facebooks, Twitters, AboutM, FavouriteMusicBands, AboutMetext, FavouriteTvShow, FavouriteText } from '../../Constant';
import LatestPhotos from '../Bonus-Ui/Tour/Leftbar/LatestPhoto';
import FollowersProfile from '../Bonus-Ui/Tour/Leftbar/Followers';
import Followingsprofile from '../Bonus-Ui/Tour/Leftbar/Followings';
import FriendsProfile from '../Bonus-Ui/Tour/Leftbar/Friends';
import { ChevronDown, ChevronUp } from 'react-feather';

const RightBar = () => {
  const [isIntro, setisIntro] = useState(true);
  return (
    <Fragment>
      <Col xl='12' className='xl-100 box-col-12'>
        <Card>
          <CardHeader>
            <H3 className='p-0 m-0'>
              <Btn className='accordion-icon' color='link' onClick={() => setisIntro(!isIntro)}>
                {ProfileIntro}
                {!isIntro && <ChevronDown />}
                {isIntro && <ChevronUp />}
              </Btn>
            </H3>
          </CardHeader>
          <Collapse isOpen={isIntro}>
            <CardBody className='filter-cards-view'>
              <div className='filter-view-group'>
                <span className='f-w-600'>{AboutM} :</span>
                <P className='m-0'>{AboutMetext}</P>
              </div>
              <div className='filter-view-group'>
                <span className='f-w-600'>{FavouriteTvShow} :</span>
                <P className='m-0'>{FavouriteText}</P>
              </div>
              <div className='filter-view-group'>
                <span className='f-w-600'>{FavouriteMusicBands} :</span>
                <P className='m-0'>{FavouriteText}</P>
              </div>
              <div className='social-network theme-form'>
                <span className='f-w-600'>{SocialNetworks}</span>
                <Btn color='social-btn btn-fb mb-2 text-center'>
                  <i className='fa fa-facebook m-r-5'></i>
                  {Facebooks}
                </Btn>
                <Btn color='social-btn btn-twitter mb-2 text-center'>
                  <i className='fa fa-twitter m-r-5'></i>
                  {Twitters}
                </Btn>
                <Btn color='social-btn btn-google text-center'>
                  <i className='fa fa-dribbble m-r-5'></i>
                  {Dribbble}
                </Btn>
              </div>
            </CardBody>
          </Collapse>
        </Card>
      </Col>
      <Col xl='12' md='6' className='xl-100 box-col-12'>
        <FollowersProfile />
      </Col>
      <Col xl='12' md='6' className='xl-100 box-col-12'>
        <Followingsprofile />
      </Col>
      <Col xl='12' md='6' className='xl-100 box-col-12'>
        <LatestPhotos />
      </Col>
      <Col xl='12' md='6' className='xl-100 box-col-12'>
        <FriendsProfile />
      </Col>
      <Col xl='12' md='12' className='xl-100 box-col-12'>
        <Card>
          <Image className='img-fluid' src={timeline4} alt='' />
        </Card>
      </Col>
    </Fragment>
  );
};

export default RightBar;
